import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

// import React-Redux
import { useSelector } from 'react-redux';

// import react-router-dom
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { routers } from './../../../routers';

import Chip from '@material-ui/core/Chip';
import { Box, Divider, Typography } from '@material-ui/core';

// import statusStyles
import { processStatusStyles } from './../../../styles/globalStyles/statusStyles';
import { chipStyles } from './../../../styles/globalStyles/dataDisplayStyles';

// import utils
import { logger } from './../../../utils/utils';

function SkeletonText() {
  return (
    <div>
      <Skeleton width="90%" variant="text" />
      <Skeleton width="80%" variant="text" />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
  ...processStatusStyles(theme),
  ...chipStyles(theme),
}));

const AppSidebarRFrontIssueActivity = ({ match }) => {
  const classes = useStyles();

  logger('AppSidebarRFront render');


  const issue = useSelector(({ issueReducer }) => issueReducer).result || {};

  return (
    <div className={classes.root}>
      <div className={classes.section1}>
        {!issue.categorys && <SkeletonText />}
        {issue.categorys && (
          <React.Fragment>
            <Typography variant="body2" component="div">
              <Box fontWeight="fontWeightBold" mb={1}>
                ประเภทของข้อมูลส่วนบุคคล
              </Box>
            </Typography>
            <Typography variant="body2">
              {issue.categorys && issue.categorys.name}
            </Typography>
          </React.Fragment>
        )}
      </div>
      <Divider variant="middle" />
      <div className={classes.section1}>
      {!issue.issues && <SkeletonText />}
      {issue.issues && (
          <React.Fragment>  <Typography variant="body2" component="div">
          <Box fontWeight="fontWeightBold" mb={2}>
            สถานะการดำเนินการ
          </Box>
        </Typography>
        <div>
          <Chip
            className={classes.chipStatusMediumStyle}
            style={
              issue.processStatuses && JSON.parse(issue.processStatuses.style)
            }
            label={issue.processStatuses && issue.processStatuses.name}
          />
        </div>
        </React.Fragment>
        )}
      </div>
    </div>
  );
};

/**
 * AppSidebarRFront() constist of routes and component in route.
 * @returns
 */
export default function AppSidebarRFront() {
  return (
    <Router>
      <Switch>
        <Route
          path={routers.frontOf.issue.path}
          exact={true}
          component={AppSidebarRFrontIssueActivity}
        />
      </Switch>
    </Router>
  );
}
